module.exports = __webpack_public_path__ + "static/img/CgoRDGREg0SAfwVIAAYPFz2J-IE191.b071502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGREg0SAfwVIAAYPFz2J-IE191.jpg
// module id = js8c
// module chunks = 73